module.exports = __webpack_public_path__ + "static/img/img-4-8.6faf110.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-4-8.png
// module id = MFmI
// module chunks = 0